<template>
  <div class="main scroll" ref="scroll">
    <div class="scroll-wrapper">
      <div class="head-title">
        <div class="left">
          <div class="main blue">
            成长册编辑
          </div>
        </div>
        <div class="right">
          <div class="num">
            成长册<span class="blue">{{ total }}</span
            >名
          </div>
          <div class="msg">
            <div class="txt blue">学生信息</div>
            <a-icon style="{color:#898989}" type="caret-down" />
          </div>
        </div>
      </div>
      <div class="content">
        <a-empty description="暂无内容" v-if="plateList.length == 0 && load" style="margin-top:40px" />
        <div class="plate-list">
          <div
            @click="tapPlate(item)"
            v-for="(item, index) in plateList"
            :key="index"
            class="cell"
          >
            <div
              class="cover"
              :style="{ backgroundImage: 'url(' + item.guc_thumb + ')' }"
            ></div>
            <div class="name">{{ item.name }}</div>
          </div>
        </div>
      </div>

      <!-- <div class="head-title">
        <div class="left">
          <div class="main blue">
            进度一览
          </div>
        </div>
        <div class="right">
        </div>
      </div>
      <div class="table">
        <a-table  rowKey='id' :pagination="false" :dataSource="table" :columns="column">
          <template slot="head_img"  slot-scope="text, record">
            <span>
              <a-avatar shape="square" :size="60" :src="record.head_img" />
            </span>
          </template>
          <template slot="actions"  slot-scope="text, record">
              <a-button @click="look(record)" type="primary" shape="round" icon="edit">查看成长册</a-button>
            </template>
        </a-table>
      </div> -->
    </div>
    
    <!-- <div class="pagebox" style="text-align:center">
      <a-pagination
        show-quick-jumper
        :defaultPageSize="24"
        :current="currentPage"
        :total="total"
        @change="onChangePage"
      />
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import { api } from "../api/api";
import pcGrowup from './pcGrowup.vue';
export default {
  data() {
    return {
      plateList: [],
      currentPage: 1,
      total: 0,
      load:false,
      spinning:false,
      column:[{
            title: '编号',
            dataIndex: 'id',
            key: 'id',
            scopedSlots: { customRender: "id" },
          },
          {
            title: '学生姓名',
            dataIndex: 'name',
            key: 'name',
            scopedSlots: { customRender: "name" },
          },{
            title: '头像',
            dataIndex: 'head_img',
            key: 'head_img',
            scopedSlots: { customRender: "head_img" },
          },{
            title: '进度',
            dataIndex: 'progress',
            key: 'progress',
            scopedSlots: { customRender: "progress" },
            sorter: (a, b) => a.grow_up_progress - b.grow_up_progress,
          },{
            title: '操作',
            dataIndex: 'actions',
            key: 'actions',
            scopedSlots: { customRender: "actions" },
          }],
      table:[],
      guc_id:'',
      sid:'',
      visible:false
    };
  },
  components:{
    pcGrowup
  },
  computed: {
    ...mapState(["headers", "userInfo"]),
  },
  created() {
    if (this.userInfo) {
      this.getPlate();
      this.getPross()
    }
  },
  watch: {
    userInfo(val) {
      if (val) {
        this.getPross()
        this.getPlate();
      }
    },
  },
  methods: {
    look(record) {
      this.spinning = true
      this.guc_id = record.guc_id
      this.sid = record.id
      this.visible = true
      setTimeout(() => {
        this.spinning = false
      }, 1500);
    },
    getPross() {
      this.$axios({
        method: "POST",
        url: api.domain + api.getPross,
        headers: { Authorization: this.$store.state.headers },
        data: {
          limit: 200,
          page: 1,
        },
      })
        .then((res) => {
          if (res.data.status == 200) {
            console.log(res)
            this.table = res.data.data.data
          }
        })
        .catch((res) => {
        });
    },
    onChangePage(e) {
      this.currentPage = e;
      this.getPlate();
    },
    tapPlate(plate) {
      this.$router.push({
        // path: "/mobileGrowup/" + '1098/' + plate.guc_id + '/100',
        path: "/growup/" + plate.id + "/" + plate.guc_id,
        query: { name: plate.name },
      });
    },
    getPlate() {
      this.plateList = [];
      
      this.$message.loading({
        key:'load',
        content:'数据读取中',
        duration:5
      })
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.growPlateList,
        headers: { Authorization: this.headers },
        params: {
          limit: 100,
          page: this.currentPage,
        },
      })
        .then((res) => {
          this.load = true
          if (res.data.status == 200) {
            this.plateList = res.data.data.list;
            this.total = res.data.data.count;
            this.$message.success({
              key:'load',
              content:'读取成功',
              duration:1
            })
          } else {
            this.$message.error({content:res.data.msg,key:"load"})
          }
          
        })
        .catch((res) => {
          this.load = true
          this.$message.error(res.data.msg);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  height: 100%;
}
.head-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  .left {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .main {
      font-size: 16px;
    }
  }
  .right {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    .msg {
      display: flex;
      flex-direction: row;
      align-items: center;
      .txt {
        margin-right: 3px;
      }
    }
  }
}
.plate-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 30px;
  flex-wrap: wrap;
  .cell {
    width: 130px;
    margin-right: 30px;
    margin-bottom: 30px;
    .cover {
      width: 100%;
      height: 168px;
      background-size: contain;
    }
    .name {
      font-size: 14px;
      color: #999;
      text-align: center;
      margin-top: 15px;
    }
  }
}

.table{
  margin-top: 30px;
  padding-bottom: 30px;
}
</style>
